import { tokens } from '../../../theme/tokens';
import { AccordionConfig } from '../../../types/accordion';
import { defineTemplate } from '../../../utils';

const BASE = `${process.env.REACT_APP_MEDIA_DOMAIN}/brands/assets/RESUMIDO/templates/thumbnails`;

const ACCORDION_CONFIG: AccordionConfig[] = [
  {
    key: 'general',
    title: 'Información general',
    subtitle: 'Configuración básica del carousel',
    fields: ['title', 'format', 'text'],
    defaultOpen: true,
    color: tokens.colors.brands.blue[200]
  },
  {
    key: 'images1',
    title: 'Imágenes 1-4',
    subtitle: 'Primeras cuatro imágenes del carousel',
    fields: ['edit_image_1', 'edit_image_2', 'edit_image_3', 'edit_image_4'],
    defaultOpen: true,
    color: tokens.colors.brands.blue[100],
    layout: 'grid'
  },
  {
    key: 'images2',
    title: 'Imágenes 5-8',
    subtitle: 'Últimas cuatro imágenes del carousel',
    fields: ['edit_image_5', 'edit_image_6', 'edit_image_7', 'edit_image_8'],
    defaultOpen: false,
    color: tokens.colors.brands.blue[100],
    layout: 'grid'
  }
];

export const resumidoCarouselGenerico = defineTemplate({
  mode: 'legacy',
  id: 'generico',
  clientId: 'RESUMIDO',
  handlerKey: 'RESUMIDO',
  title: 'Carousel genérico',
  thumbnail: {
    url: `${BASE}/carrusel-generico-vertical.png`,
    optimizedUrl: `${BASE}/optimized/carrusel-generico-vertical.png`,

    aspectRatio: 'vertical'
  },
  renderConfig: { renderer: 'accordion', accordionConfig: ACCORDION_CONFIG },
  formFields: [
    {
      key: 'title',
      label: 'Nombre del proyecto',
      type: 'input',
      placeholder: 'Nombre para identificar este asset',
      required: true
    },
    { key: 'text', label: 'Texto', type: 'input', placeholder: 'Texto descriptivo', required: true },
    {
      key: 'format',
      label: 'Formato de salida',
      type: 'select',
      required: true,
      options: [
        { value: 'vertical', label: 'Vertical (9:16)' },
        { value: 'wide', label: 'Wide (16:9)' },
        { value: 'both', label: 'Ambos formatos' }
      ]
    },
    {
      key: 'edit_image_1',
      label: 'Portada 1',
      type: 'image',
      placeholder: 'https://ejemplo.com/portada1.jpg',
      required: true
    },
    {
      key: 'edit_image_2',
      label: 'Portada 2',
      type: 'image',
      placeholder: 'https://ejemplo.com/portada2.jpg',
      required: true
    },
    {
      key: 'edit_image_3',
      label: 'Portada 3',
      type: 'image',
      placeholder: 'https://ejemplo.com/portada3.jpg',
      required: true
    },
    {
      key: 'edit_image_4',
      label: 'Portada 4',
      type: 'image',
      placeholder: 'https://ejemplo.com/portada4.jpg',
      required: true
    },
    {
      key: 'edit_image_5',
      label: 'Portada 5',
      type: 'image',
      placeholder: 'https://ejemplo.com/portada5.jpg',
      required: true
    },
    {
      key: 'edit_image_6',
      label: 'Portada 6',
      type: 'image',
      placeholder: 'https://ejemplo.com/portada6.jpg',
      required: true
    },
    {
      key: 'edit_image_7',
      label: 'Portada 7',
      type: 'image',
      placeholder: 'https://ejemplo.com/portada7.jpg',
      required: true
    },
    {
      key: 'edit_image_8',
      label: 'Portada 8',
      type: 'image',
      placeholder: 'https://ejemplo.com/portada8.jpg',
      required: true
    }
  ],
  promptTemplate: `Haceme un asset "Carrusel Genérico" en formato vertical y wide usando estas imágenes
1. "${process.env.REACT_APP_MEDIA_DOMAIN}/brands/para-testear/resumido/01.jpg"
2. "${process.env.REACT_APP_MEDIA_DOMAIN}/brands/para-testear/resumido/02.jpg"
3. "${process.env.REACT_APP_MEDIA_DOMAIN}/brands/para-testear/resumido/03.jpg"
4. "${process.env.REACT_APP_MEDIA_DOMAIN}/brands/para-testear/resumido/04.jpg"
5. "${process.env.REACT_APP_MEDIA_DOMAIN}/brands/para-testear/resumido/05.jpg"
6. "${process.env.REACT_APP_MEDIA_DOMAIN}/brands/para-testear/resumido/06.jpg"
7. "${process.env.REACT_APP_MEDIA_DOMAIN}/brands/para-testear/resumido/07.jpg"
8. "${process.env.REACT_APP_MEDIA_DOMAIN}/brands/para-testear/resumido/08.jpg"`
});
